import { TextField } from '../../atoms';
import { FORM_CLASSIFIERS_INVOICE_DATE_EDIT } from '../../constants/formKeys';
import {
  getClassifiersInvoiceDateChange,
  getClassifiersInvoiceDateItem,
  getClassifiersInvoiceDateItemData,
} from '../../reducers/classifiersReducer';
import * as actions from '../../actions/actionCreators/classifiersActionCreators';
import { invoiceDate } from '../../constants/parameters';
import createParameterEditor from '../createParameterEditor';

export default createParameterEditor({
  title: 'parameterInvoiceDateTitle',
  formKey: FORM_CLASSIFIERS_INVOICE_DATE_EDIT,
  fields: [
    {
      name: invoiceDate.VALUE,
      label: 'fieldInvoiceDate',
      component: TextField,
      className: 'date-field',
    },
  ],
  fetchAction: actions.fetchClassifierInvoiceDate,
  changeAction: actions.changeClassifierInvoiceDate,
  getChangeSelector: getClassifiersInvoiceDateChange,
  getItemSelector: getClassifiersInvoiceDateItem,
  getInitialValues: (state) => getClassifiersInvoiceDateItemData(state)?.toJS(),
});
